import {BaseAnimation} from './BaseAnimation';

export class FadeAnimation extends BaseAnimation {

    private fromValue:number|'auto'='auto';
    private toValue:number|'auto'='auto';

    public getClass():string {
        return 'fade-animation';
    }

    public after() {
        super.after();
        if (this.toValue==1) this.element.css('opacity','');
        if (this.toValue==0) this.element.css('display','');
    }

    public from(opacity:number|'auto') {
        this.fromValue=opacity;
        if (opacity=='auto') {
            if (this.initialDisplay=='none') opacity=0; else opacity=parseFloat(this.element.css('opacity'));
        }
        this.fromItem.css('opacity',opacity);
        return this;
    }

    public to(opacity:number|'auto') {
        this.toValue=opacity;
        if (opacity=='auto') opacity=parseFloat(this.element.css('opacity'));
        this.toItem.css('opacity',opacity);
        return this;
    }

}

export {};